// extracted by css-extract-rspack-plugin
export default {"cls1":"PapersSearch-cls1_E6R","cls2":"PapersSearch-cls2_qWz PapersSearch-cls1_E6R"};